import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { GroupFeatureAccessService } from './group-feature-access.service';

/**
 * Route guard that prevents navigating to creation and edit routes when the group is locked
 * due to overdue subscription payment.
 */
export const groupWriteAccessGuard: CanActivateFn = (route, state) => {
  const accessService = inject(GroupFeatureAccessService);
  const router = inject(Router);

  let groupId = route.paramMap.get('id');
  if (!groupId) {
    let parent = route.parent;
    while (parent) {
      groupId = parent.paramMap.get('id');
      if (groupId) break;
      parent = parent.parent;
    }
  }

  return accessService.isLocked$.pipe(
    take(1),
    map((isLocked) => {
      if (isLocked) {
        // Trigger dialog informing that features are disabled
        accessService.checkActionAllowed(true);
        if (groupId) {
          router.navigate(['/groups', groupId]);
        }
        return false;
      }
      return true;
    }),
  );
};
